import { Permissions } from "src/api/generated/iam/permissions.ts";
import { CustomerOfferLineConfiguringHiddenParams } from "src/tenantCustomizations/TenantCustomizations.ts";
import { decodeObjectAttributeValue } from "src/components/views/erp/objectAttributes/objectAttributeValueConverting.ts";

/** Checkbox attribute of customer offers that Salvos Studio sets on the offers it designs. */
const DESIGNED_WITH_STUDIO_ATTRIBUTE_FIELD_ID = 2;

/**
 * Offers designed with Salvos Studio are configured in Studio, so only users who manage all offers may configure
 * their lines in Aavo.
 */
export function isSalvosStudioOfferLineConfiguringHidden({
	customerOfferAttributes,
	hasPermission,
}: CustomerOfferLineConfiguringHiddenParams): boolean {
	if (hasPermission(Permissions.Sales.CustomerOffers.MANAGE_ALL)) return false;

	const dbValue = customerOfferAttributes.find(
		(attribute) => attribute.attributeFieldId === DESIGNED_WITH_STUDIO_ATTRIBUTE_FIELD_ID,
	)?.attributeValue;
	return decodeObjectAttributeValue(dbValue ?? null, { type: "checkbox" }).value === true;
}
